// @flow
import { createParser, fields } from '../utils/parse';

export const Package = createParser('PackageParser', {
  id: fields.number(-1),
  name: fields.string(''),
  partnerName: fields.string('Paperless Post', { path: 'partner.name' }),
  gridImage: fields.string('', { path: 'grid_image_url' }),
  carouselImage: fields.string('', { path: 'carousel_image_url' }),
  palette: fields.string('', { path: 'palette_url' }),
  shape: fields.string(''),
  eventType: fields.string('', { path: 'event_type' }),
});

export default Package;
